import { render, staticRenderFns } from "./PlatformColorPalette_list.vue?vue&type=template&id=44cdec9e&scoped=true&"
import script from "./PlatformColorPalette_list.vue?vue&type=script&lang=js&"
export * from "./PlatformColorPalette_list.vue?vue&type=script&lang=js&"
import style0 from "./PlatformColorPalette_list.vue?vue&type=style&index=0&id=44cdec9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cdec9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
